<template>
  <Modal
      v-model="_value"
      width="500"
      title="车辆信息审核"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk"
      cancel-text="关闭">
    <Form :model="checkResult" style="display: inline;">
      <FormItem prop="state">
        <label style="display: inline-block; width: 60px;">状态</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="checkResult.pass1">
          <Option v-for="item in pass" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="result">
        <label style="display: inline-block; width: 60px;">不通过原因</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="checkResult.reason" placeholder="不通过原因">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'checkvehicleinfomodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      pass: [
        { label: '通过', value: 1 },
        { label: '不通过', value: 0 }
      ],
      checkResult: {
        id: null,
        pass1: null,
        pass: null,
        reason: null
      },
      vehicleInfo: {
        id: null,
        businessState: null
      }
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_GetDetail',
      'VehicleInfoServ_AddCheck',
      'VehicleInfoServ_ModifyCheck'
    ]),
    onOk () {
      console.log('onOk')
      this.$Modal.confirm({
        title: '确认审核',
        content: '<p>确认审核</p>',
        onOk: () => {
          if (this.checkResult.pass1 === 1) {
            this.checkResult.pass = true
          } else {
            this.checkResult.pass = false
          }
          console.log(this.checkResult)
          if (this.vehicleInfo.businessState === 2) {
            store.dispatch('VehicleInfoServ_AddCheck', {
              params: this.checkResult
            }).then(() => {
              this.$Message.success('审核完成')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          } else if (this.vehicleInfo.businessState === 3) {
            store.dispatch('VehicleInfoServ_ModifyCheck', {
              params: this.checkResult
            }).then(() => {
              this.$Message.success('审核完成')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          }
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.vehicleInfo.id = null
        this.vehicleInfo.businessState = null
        this.checkResult.id = null
        this.checkResult.pass = true
        this.checkResult.reason = null
        let id = this._initValue
        if (id) {
          store.dispatch('VehicleInfoServ_GetDetail', {
            params: { id: this._initValue }
          }).then(() => {
            this.vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
            this.checkResult.id = this.vehicleInfo.id
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
